export const USER_FUNCTION_EDIT = "USER_FUNCTION_EDIT"
export const USER_FUNCTION_EDIT_SUCCESS = "USER_FUNCTION_EDIT_SUCCESS"
export const USER_FUNCTION_EDIT_ERROR = "USER_FUNCTION_EDIT_ERROR"
